import type { Database } from "@/integrations/supabase/types";
import type { Brand } from "@/hooks/useBrands";

export type CampaignRow = Database["public"]["Tables"]["campaigns"]["Row"];
export type CampaignInsert = Database["public"]["Tables"]["campaigns"]["Insert"];
export type CampaignInfluencerInsert = Database["public"]["Tables"]["campaign_influencers"]["Insert"];
export type CampaignGoal = Database["public"]["Enums"]["campaign_goal_enum"];
export type CampaignPlatform = Database["public"]["Enums"]["platform_enum"];
export type InfluencerInsert = Database["public"]["Tables"]["influencers"]["Insert"];
export type InfluencerRow = Database["public"]["Tables"]["influencers"]["Row"];

export interface CampaignFormData {
  name: string;
  brandId: string;
  hashtags: string;
  upgradeAlerts: boolean;
  flagMissingAdDisclosure: boolean;
  enableEventMode: boolean;
  campaignType: CampaignGoal;
  platforms: CampaignPlatform[];
  totalBudget: string;
  startDate: string;
  endDate: string;
}

export interface CampaignCreationFormProps {
  onClose: () => void;
  onSubmit: (campaignData: CampaignRow) => void;
  prefilledData?: {
    brandId?: string;
    influencerId?: string;
  };
}

export interface CampaignFormStep1Props {
  formData: CampaignFormData;
  isBrandOrg: boolean;
  brands: Brand[] | undefined;
  brandsLoading: boolean;
  currentOrgName: string | undefined;
  createLoading: boolean;
  createError: string | null;
  userCountry: string | null;
  onUpdateFormData: <Field extends keyof CampaignFormData>(field: Field, value: CampaignFormData[Field]) => void;
  onEndDateTouched: () => void;
  onNext: () => void;
  onClose: () => void;
  onAddBrandClick: () => void;
}

/** Column headers recognized as username columns in imported CSV files. */
export const USERNAME_COLUMNS = new Set(["username", "instagram_handle", "handle"]);

/** Default deliverables assigned to newly attached campaign influencers. */
export const DEFAULT_DELIVERABLES = '1 Reel + 1 Story';

/** Default status assigned to newly attached campaign influencers. */
export const DEFAULT_INFLUENCER_STATUS = 'contacted';

/** Default campaign status on creation. */
export const DEFAULT_CAMPAIGN_STATUS = 'draft';

/** Default kanban stage on creation. */
export const DEFAULT_KANBAN_STAGE = 'discovery';
